import moment from 'moment';
import vi from "moment/locale/vi";
import es from "moment/locale/es";

const numberDisplay = (x, separator = ',', precision = 0) => {
  if (!x) return 0;
  const string = x.toFixed(precision).toString();
  const arr = string.split('.');

  const before = arr[0]
    // .replace(/[^0-9]/g, '')
    .replace(/\B(?=(\d{3})+(?!\d))/g, separator);

  if (precision > 0) {
    const after = arr[1] || '00';
    return `${before}.${after}`;
  }
  return before;
};

const moneyDisplay = (x, separator = ',', precision = 0) => {
  if (!x) return 0;
  const string = x.toFixed(precision).toString();
  const arr = string.split('.');

  const before = arr[0]
    // .replace(/[^0-9]/g, '')
    .replace(/\B(?=(\d{3})+(?!\d))/g, separator);
    
  if (precision > 0) {
    const after = arr[1] || '00';
    return `${before}.${after}`;
  }
  if (x > 0) {
    return `+${before}`;
  } else {
    return `${before}`;
  }
};

const shortMoneyDisplay = (x, separator = ',', precision = 0) => {
  return `${moneyDisplay(x/1000000, ',', 2)}`
};

const priceDisplay = (x, unit = '$') => {
  return `${unit}${numberDisplay(x, ',', 2)}`;
};

const numberDisplayFloat = (x, position = 2) => {
  return `${numberDisplay(x, ',', position)}`;
};

const numberValue = (x) => {
  return x.replace(/[^0-9]/g, '');
};

const dateDisplay = (x) => {
  return x ? moment(x).format('DD-MM-YYYY') : 'N/A';
};

const shortDateDisplay = (x) => {
  return x ? moment(x).format('DD-MM') : 'N/A';
};

const datetimeDisplay = (x, locale) => {
  const data = moment.tz(x, Intl.DateTimeFormat().resolvedOptions().timeZone);
  if (locale && locale === 'vi') {
    return data ? moment(data).locale("vi").format('DD/MM/YYYY h:mm:ss A') : 'N/A';  
  }
  return data ? moment(data).locale("es").format('DD/MM/YYYY HH:mm:ss A') : 'N/A';
};

const percentDisplay = (x, unit = '--%') => {
  return x ? (_.round(x * 100, 1)).toString() + '%' : `${unit}`;
};

const scrollTop = () => {
  document.body.scrollTop = 0; // For Safari
  document.documentElement.scrollTop = 0; // For Chrome, Firefox, IE and Opera
};

export default {
  numberDisplay,
  numberDisplayFloat,
  dateDisplay,
  datetimeDisplay,
  priceDisplay,
  scrollTop,
  numberValue,
  shortDateDisplay,
  percentDisplay,
  moneyDisplay,
  shortMoneyDisplay
};
